// @ts-nocheck
/* eslint-disable */

  /**
  * Do not change! File was auto generate. 
  *
  */
  
import React from 'react';

import { ReactComponent as AwesomeStarsComponent} from './AwesomeStars.svg';

import Icon, { TIconProps } from '../Icon';

export const IconAwesomeStars = React.forwardRef<any, TIconProps>((props, ref) => (
  <Icon
    ref={ref}
    {...props}
  >
    <AwesomeStarsComponent/>
  </Icon>
));
